import { initSwiperWebinarsWithResize } from './swiper-webinars-template';

import { initWebinarGate } from './hubspot-gated-form.js';

// ─── Swiper ───────────────────────────────────────────────────────────────────

initSwiperWebinarsWithResize();
initWebinarGate();
